export default "<div class=\"container relative\">\n  <a (click)=\"goTo()\" class=\"button__close\"></a>\n</div>"